import { Vector3 } from "three";
import { Obj } from "../internal";
/**
 * Measure point parent object
 * @typedef {mmObject} mmMeasurePoint
 * @class MeasurePoint
 * @extends Obj
 * @constructor
 */
export class MeasurePoint extends Obj {
    constructor() {
        super();
        this.Northing = 0;
        this.precLocalY = 0;
        this.precLocalNorthing = 0;
        this.precGlobalNorthing = 0;
        this.Easting = 0;
        this.precLocalX = 0;
        this.precLocalEasting = 0;
        this.precGlobalEasting = 0;
        this.Height = 0;
        this.precLocalZ = 0;
        this.precLocalHeight = 0;
        this.precGlobalHeight = 0;
        this.Omega = 0;
        this.Phi = 0;
        this.Kappa = 0;
        this.quality = 0;
        /**
         * is set to true if calculation could be inaccurate. see warntext for details
         * @type {boolean}
         */
        this.warning = false;
        /**
         * further information why calculation could be inacurrate
         * @type {string}
         */
        this.warntext = "";
        this.distance = 0;
        this.geoframe = null;
        this.maxdist = 0;
        /**
         * Frame coordinates.
         */
        this.frameX = 0;
        this.frameY = 0;
        this.frameZ = 0;
        this.precFrameX = 0;
        this.precFrameY = 0;
        this.precFrameZ = 0;
    }
    isValid() {
        if (!isFinite(this.Easting) ||
            isNaN(this.Easting) ||
            !isFinite(this.Northing) ||
            isNaN(this.Northing) ||
            !isFinite(this.Height) ||
            isNaN(this.Height)) {
            return false;
        }
        return true;
    }
    /**
     * returns the point values as vec3 object.
     * @return {Vector3}
     */
    getVec3() {
        const vec = new Vector3(this["Easting"], this["Northing"], this["Height"]);
        return vec;
    }
    /**
     * checks if the measurement is in Range
     */
    checkCoordinates() {
        return;
    }
    copy() {
        return this;
    }
}
//# sourceMappingURL=measurepoint.js.map